"use client";

import * as React from "react";
import { Check, Copy } from "lucide-react";
import { Button } from "@/components/catalyst/button";
import { notify } from "@/components/ui/toast";
import { motion, AnimatePresence } from "motion/react";

export function ContactMe() {
  const [copied, setCopied] = React.useState(false);
  const email = "karl@karlkoch.me";

  return (
    <div className="flex gap-2">
      <Button
        className="text-background w-full md:w-fit"
        name="Copy email to clipboard"
        onClick={() => notify({ content: email, setCopied })}
      >
        <div className="relative flex h-full w-full items-center">
          <AnimatePresence mode="popLayout" initial={false}>
            {copied ? (
              <motion.div
                key="copied"
                initial={{ y: -30 }}
                animate={{ y: 0 }}
                exit={{ y: 30 }}
                className="flex h-full items-center"
              >
                Copied!
              </motion.div>
            ) : (
              <motion.div
                key="email"
                initial={{ y: -30 }}
                animate={{ y: 0 }}
                exit={{ y: 30 }}
                className="flex h-full items-center"
              >
                {email}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
        {copied ? (
          <Check size={16} className="shrink-0" />
        ) : (
          <Copy size={16} className="shrink-0" />
        )}
      </Button>
    </div>
  );
}
